import AdminForgotPasswordWrapper from "../../components/Admin/AdminForgotPasswordPage/AdminLoginWrapper/AdminForgotPasswordWrapper";

type Props = {};

const ForgotPasswordPage = (props: Props) => {
  return <AdminForgotPasswordWrapper />;
};

export default ForgotPasswordPage;
